// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useAdminAuth } from "../../auth/AdminAuthProvider";
// import { BASE_URL } from "../../../env";
// import DashboardHeader from "../../../components/layout/DashboardHeader";
// import Sidebar from "../../../components/layout/Sidebar";
// import { InputGroup, FormControl, Button, Row, Col } from "react-bootstrap";
// import MemberDetailsModal from "../components/MemberDetailsModal";
// import { IoSearch, IoDocumentTextOutline } from "react-icons/io5";
// import { useLocation } from "react-router-dom";
// import ActionButtons from "../../workflows/components/ActionButtons";
// import Zoom from "react-medium-image-zoom";
// import { MdContentPasteSearch, MdDateRange } from "react-icons/md";
// import { FaLocationDot } from "react-icons/fa6";
// import { FaAngleRight, FaUser } from "react-icons/fa";
// import { Dropdown } from "react-bootstrap";
// import Select from "react-select";
// import DeleteConfirmationModal from "../../../components/ui/DeleteConfirmationModal";
// import { FiSearch } from "react-icons/fi";
// import { GrFormNext, GrFormNextLink } from "react-icons/gr";

// const MemberDetails = () => {
//   const location = useLocation();
//   const { filterStatus, loanType , loanStyle} = location.state || {};
//   const { adminUser } = useAdminAuth();

//   const [openSidebarToggle, setOpenSidebarToggle] = useState(window.innerWidth > 992);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [selectedBranches, setSelectedBranches] = useState([]);
//   const [selectedCros, setSelectedCros] = useState([]);
//   const [memberData, setMemberData] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage] = useState(10);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedMemberId, setSelectedMemberId] = useState(null);
//   const [showDelModal, setShowDelModal] = useState(false);

//   // Extract unique branches for the select options

//   const branchOptions = [
//     ...new Set(memberData.map((member) => member.branchName)),
//   ].map((branch) => ({
//     label: branch,
//     value: branch,
//   }));

//   const croOptions = [
//     ...new Set(memberData.map((member) => member.croName)),
//   ].map((cro) => ({
//     label: cro,
//     value: cro,
//   }));

//   const OpenSidebar = () => {
//     setOpenSidebarToggle(!openSidebarToggle);
//   };
//   const fetchMemberDetails = useCallback(async () => {
//     try {
//       const params = {};
//       let getMemberDetails = "";
//       params.loanType = loanType || "";
//       if (
//         loanType === "Business Loan" &&
//         adminUser.userType === "Branch Manager"
//       ) {
//         getMemberDetails = "getMemberDetailsByBranchManager";
//         params.branchManagerId = adminUser.user.id;
//         if (filterStatus === "approved") {
//           params.branchManagerStatus = ["submitted", "disbursed"];
//         }
//         if (filterStatus === "pending") {
//           params.branchManagerStatus = "pending";
//           params.fieldManagerStatus = "submitted";
//         }
//         if (filterStatus === "retrigger") {
//           params.branchManagerStatus = "retrigger";
//         }
//         if (filterStatus === "disbursed") {
//           params.fieldManagerStatus = "submitted";
//           params.branchManagerStatus = "submitted";
//           params.creditOfficerStatus = "submitted";
//           params.misStatus = "submitted";
//           params.creditManagerStatus = "submitted";
//           params.sanctionCommitteeStatus = "approved";
//           params.accountManagerStatus = "pending";
//         }
//         if (filterStatus === "rejected") {
//           params.branchManagerStatus = "rejected";
//         }
//       }
//       if (
//         loanType === "Business Loan" &&
//         adminUser.userType === "Credit Officer"
//       ) {
//         getMemberDetails = "getMemberDetailsByCreditOfficer";
//         params.creditOfficerId = adminUser.user.id;
//         if (filterStatus === "approved") {
//           params.creditOfficerStatus = "submitted";
//         }
//         if (filterStatus === "pending") {
//           params.creditOfficerStatus = "pending";
//           params.branchManagerStatus = "submitted";
//         }
//         if (filterStatus === "retrigger") {
//           params.creditOfficerStatus = "retrigger";
//         }
//         if (filterStatus === "rejected") {
//           params.creditOfficerStatus = "rejected";
//         }
//       }
//       if (loanType === "Business Loan" && adminUser.userType === "MIS") {
//         getMemberDetails = "getMemberDetailsByMis";
//         params.misId = adminUser.user.id;
//         if (filterStatus === "approved") {
//           params.misStatus = ["submitted", "disbursed"];
//         }
//         if (filterStatus === "pending") {
//           params.misStatus = "pending";
//           params.creditOfficerStatus = "submitted";
//         }
//         if (filterStatus === "retrigger") {
//           params.misStatus = "retrigger";
//         }
//         if (filterStatus === "disbursed") {
//           params.fieldManagerStatus = "submitted";
//           params.branchManagerStatus = "disbursed";
//           params.creditOfficerStatus = "submitted";
//           params.misStatus = "submitted";
//           params.creditManagerStatus = "submitted";
//           params.sanctionCommitteeStatus = "approved";
//           params.accountManagerStatus = "pending";
//         }
//         if (filterStatus === "rejected") {
//           params.misStatus = "rejected";
//         }
//       }
//       if (
//         loanType === "Business Loan" &&
//         adminUser.userType === "Credit Manager"
//       ) {
//         getMemberDetails = "getMemberDetailsByCreditManager";
//         params.creditManagerId = adminUser.user.id;
//         if (filterStatus === "approved") {
//           params.creditManagerStatus = "submitted";
//         }
//         if (filterStatus === "pending") {
//           params.creditManagerStatus = "pending";
//           params.misStatus = "submitted";
//         }
//         if (filterStatus === "retrigger") {
//           params.creditManagerStatus = "retrigger";
//         }
//         if (filterStatus === "rejected") {
//           params.creditManagerStatus = "rejected";
//         }
//       }
//       if (
//         loanType === "Business Loan" &&
//         adminUser.userType === "Sanction Committee"
//       ) {
//         getMemberDetails = "getMemberDetailsBySanctionCommittee";
//         params.sanctionCommitteeId = adminUser.user.id;
//         if (filterStatus === "approved") {
//           params.sanctionCommitteeStatus = "approved";
//         }
//         if (filterStatus === "pending") {
//           params.sanctionCommitteeStatus = "pending";
//           params.creditManagerStatus = "submitted";
//         }
//         if (filterStatus === "retrigger") {
//           params.sanctionCommitteeStatus = "retrigger";
//         }
//         if (filterStatus === "rejected") {
//           params.sanctionCommitteeStatus = "rejected";
//         }
//       }
//       if (
//         loanType === "Business Loan" &&
//         adminUser.userType === "Accounts Manager"
//       ) {
//         getMemberDetails = "getMemberDetailsByAccountsManager";
//         params.accountManagerId = adminUser.user.id;
//         if (filterStatus === "approved") {
//           params.accountManagerStatus = "payment credited";
//         }
//         if (filterStatus === "pending") {
//           params.accountManagerStatus = "pending";
//           params.misStatus = "disbursed";
//         }
//         if (filterStatus === "retrigger") {
//           params.accountManagerStatus = "retrigger";
//         }
//       }
//       if (loanType === "GP Loan" && adminUser.userType === "MIS") {
//         getMemberDetails = "getMemberDetailsByMis";
//         params.misId = adminUser.user.id;
//         if (filterStatus === "approved") {
//           params.misStatus = ["submitted", "orderPlaced", "recheckFinally"];
//         }
//         if (filterStatus === "pending") {
//           params.misStatus = "pending";
//           params.creditOfficerStatus = "submitted";
//         }
//         if (filterStatus === "retrigger") {
//           params.misStatus = "retrigger";
//         }
//         if (filterStatus === "orderPlaced") {
//           params.fieldManagerStatus = "submitted";
//           params.creditOfficerStatus = "submitted";
//           params.misStatus = "submitted";
//           params.creditManagerStatus = "submitted";
//           params.sanctionCommitteeStatus = "approved";
//           params.branchManagerStatus = "submitted";
//         }
//         if (filterStatus === "recheckFinally") {
//           params.fieldManagerStatus = "submitted";
//           params.creditOfficerStatus = "submitted";
//           params.creditManagerStatus = "submitted";
//           params.sanctionCommitteeStatus = "approved";
//           params.misStatus = "orderPlaced";
//           params.branchManagerStatus = "disbursed";
//           params.accountManagerStatus = "pending";
//         }
//         if (filterStatus === "rejected") {
//           params.misStatus = "rejected";
//         }
//       }
//       if (loanType === "GP Loan" && adminUser.userType === "Credit Manager") {
//         getMemberDetails = "getMemberDetailsByCreditManager";
//         params.creditManagerId = adminUser.user.id;
//         if (filterStatus === "approved") {
//           params.creditManagerStatus = "submitted";
//         }
//         if (filterStatus === "pending") {
//           params.creditManagerStatus = "pending";
//           params.misStatus = "orderPlaced";

//           // params.filedManagerStatus = "topuploan";
//         }
//         if (filterStatus === "retrigger") {
//           params.creditManagerStatus = "retrigger";
//         }
//         if (filterStatus === "rejected") {
//           params.creditManagerStatus = "rejected";
//         }
//       }
//       if (
//         loanType === "GP Loan" &&
//         adminUser.userType === "Sanction Committee"
//       ) {
//         getMemberDetails = "getMemberDetailsBySanctionCommittee";
//         params.sanctionCommitteeId = adminUser.user.id;
//         if (filterStatus === "approved") {
//           params.sanctionCommitteeStatus = "approved";
//         }
//         if (filterStatus === "pending") {
//           params.sanctionCommitteeStatus = "pending";
//           params.creditManagerStatus = "submitted";
//         }
//         if (filterStatus === "retrigger") {
//           params.sanctionCommitteeStatus = "retrigger";
//         }
//         if (filterStatus === "rejected") {
//           params.sanctionCommitteeStatus = "rejected";
//         }
//       }
//       if (loanType === "GP Loan" && adminUser.userType === "Branch Manager") {
//         getMemberDetails = "getMemberDetailsByBranchManager";
//         params.branchManagerId = adminUser.user.id;
//         if (filterStatus === "approved") {
//           params.branchManagerStatus = ["submitted", "disbursed"];
//         }
//         if (filterStatus === "pending") {
//           params.branchManagerStatus = "pending";
//           params.sanctionCommitteeStatus = "approved";
//           params.misStatus = "submitted";
//         }
//         if (filterStatus === "retrigger") {
//           params.branchManagerStatus = "retrigger";
//         }
//         if (filterStatus === "disbursed") {
//           params.fieldManagerStatus = "submitted";
//           params.creditOfficerStatus = "submitted";
//           params.creditManagerStatus = "submitted";
//           params.sanctionCommitteeStatus = "approved";
//           params.branchManagerStatus = "submitted";
//           params.misStatus = "orderPlaced";
//           params.accountManagerStatus = "pending";
//         }
//         if (filterStatus === "rejected") {
//           params.branchManagerStatus = "rejected";
//         }
//       }
//       if (loanType === "GP Loan" && adminUser.userType === "Accounts Manager") {
//         getMemberDetails = "getMemberDetailsByAccountsManager";
//         params.accountManagerId = adminUser.user.id;
//         if (filterStatus === "approved") {
//           params.accountManagerStatus = "payment credited";
//         }
//         if (filterStatus === "pending") {
//           params.accountManagerStatus = "pending";
//           params.misStatus = "recheckFinally";
//         }
//         if (filterStatus === "retrigger") {
//           params.accountManagerStatus = "retrigger";
//         }
//       }

//       if (
//         adminUser.userType === "superadmin" ||
//         adminUser.userType === "developer"
//       ) {
//         getMemberDetails = "getMemberDetailsBySuperadmin";
//         params.superadminId = adminUser.user.id;
//         if (filterStatus === "approved") {
//           params.accountManagerStatus = "payment credited";
//         }
//       }
//       const response = await axios.get(`${BASE_URL}/api/${getMemberDetails}`, {
//         params,
//       });
//       // console.log("Response: " + JSON.stringify(response.data.list));
//       if (
//         (adminUser.userType === "superadmin" ||
//           adminUser.userType === "developer") &&
//         filterStatus === "rejected"
//       ) {
//         const filteredList = response.data.list.filter((member) =>
//           [
//             "branchManagerStatus",
//             "creditOfficerStatus",
//             "misStatus",
//             "creditManagerStatus",
//             "sanctionCommitteeStatus",
//           ].some((status) => member[status] === "rejected")
//         );
//         setMemberData(filteredList);
//       } else if (
//         (adminUser.userType === "superadmin" ||
//           adminUser.userType === "developer") &&
//         filterStatus === "pending"
//       ) {
//         const filteredList = response.data.list.filter(
//           (member) =>
//             member.accountManagerStatus === "pending" &&
//             [
//               "branchManagerStatus",
//               "creditOfficerStatus",
//               "misStatus",
//               "creditManagerStatus",
//               "sanctionCommitteeStatus",
//             ].every((status) => member[status] !== "rejected")
//         );
//         setMemberData(filteredList);
//       } else {
//         setMemberData(response.data.list);
//       }
//     } catch (error) {
//       console.error("Error fetching member details:", error);
//     }
//   }, [adminUser.user.id, adminUser.userType, filterStatus, loanType]);

//   useEffect(() => {
//     fetchMemberDetails();
//   }, [fetchMemberDetails]);

//   const filteredMembers = memberData.filter((member) => {
//     // Normalize the searchTerm
//     const normalizedSearchTerm = searchTerm.toLowerCase();

//     // Parse `fromDate` and `toDate` into comparable Date objects
//     const fromDateObj = fromDate ? new Date(fromDate) : null;
//     const toDateObj = toDate ? new Date(toDate) : null;

//     // Check if the searchTerm matches text fields
//     const matchesTextFields =
//       member.memberName.toLowerCase().includes(normalizedSearchTerm) ||
//       member.ApplicationId.toLowerCase().includes(normalizedSearchTerm);

//     // Check if the memberCreatedAt falls within the date range
//     const createdAtDateObj = new Date(
//       member.createdAt // Raw date for comparison
//     );

//     // Normalize both createdAt and toDate to only consider the date portion (ignore time)
//     const isSameDateOrBefore = (date1, date2) => {
//       return (
//         date1.getFullYear() === date2.getFullYear() &&
//         date1.getMonth() === date2.getMonth() &&
//         date1.getDate() === date2.getDate()
//       );
//     };

//     const matchesDateRange =
//       (!fromDateObj || createdAtDateObj >= fromDateObj) &&
//       (!toDateObj ||
//         createdAtDateObj <= toDateObj ||
//         isSameDateOrBefore(createdAtDateObj, toDateObj));

//     // Check if the member's branch matches the selected branches
//     const matchesBranch =
//       selectedBranches.length === 0 ||
//       selectedBranches.some((branch) => branch.value === member.branchName);

//     // Check if the member's croName matches the selected cro's
//     const matchesCro =
//       selectedCros.length === 0 ||
//       selectedCros.some((cro) => cro.value === member.croName);

//     // Return true if text fields, date range,branches and cro's match
//     return matchesTextFields && matchesDateRange && matchesBranch && matchesCro;
//   });

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredMembers.slice(indexOfFirstItem, indexOfLastItem);

//   const totalPages = Math.ceil(filteredMembers.length / itemsPerPage);

//   const handlePageChange = (pageNumber) => {
//     if (pageNumber > 0 && pageNumber <= totalPages) {
//       setCurrentPage(pageNumber);
//     }
//   };

//   const handleShowModal = (memberId) => {
//     setSelectedMemberId(memberId);
//     setShowModal(true);
//   };

//   const handleDelMember = (memberId) => {
//     console.log("setSelectedMemberId: " + memberId);
//     setSelectedMemberId(memberId);
//     setShowDelModal(true);
//   };

//   const handleSubmitAlert = useCallback(
//     async (event) => {
//       event.preventDefault();
//       const clickedButton = event.nativeEvent.submitter;
//       const buttonValue = clickedButton.getAttribute("name");

//       if (buttonValue === "Yes") {
//         console.log("Yes button clicked ");
//         console.log("Selected memberId: " + selectedMemberId);
//         try {
//           const res = await axios.post(`${BASE_URL}/api/delMember`, {
//             memberId: selectedMemberId,
//           });
//           if (res.data.message) {
//             console.log("Deleted Successfully: " + selectedMemberId);
//           } else if (res.data.error) {
//             console.log("error from api: " + res.data.error);
//           }
//         } catch (error) {
//           console.log("error in catch: " + error);
//         } finally {
//           fetchMemberDetails();
//           setShowDelModal(false);
//         }
//       } else if (buttonValue === "No") {
//         console.log("No button clicked ");
//         setShowDelModal(false);
//       }
//     },
//     [selectedMemberId, fetchMemberDetails]
//   );

//   return (
//     <div className="dashboard-over">
//       <div className="d-flex">
//         <div>
//           <Sidebar
//             openSidebarToggle={openSidebarToggle}
//             OpenSidebar={OpenSidebar}
//           />
//         </div>
//         <div
//           className=""
//           style={{
//             overflowY: "scroll",
//             height: "100vh",
//             scrollbarWidth: "none",
//             backgroundColor: "#181818",
//           }}
//         >
//           <div style={{ height: "14%" }}>
//             <DashboardHeader OpenSidebar={OpenSidebar} />
//           </div>

//           <div
//             className="member-details "
//             style={{
//               height: "86%",
//               borderRadius: "40px 0px 0px 0px",
//               backgroundColor: "white",
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 padding: "8px 18px",
//                 alignItems: "center",
//                 width: "100%",
//                 height: "14%",
//                 position: "relative",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "8px",
//                   position: "absolute",
//                   zIndex: "5",
//                   width: "97%",
//                 }}
//               >
//                 <div className="input-fields">
//                   <input
//                     type="date"
//                     style={{ border: "none", opacity: "0.7" }}
//                     value={fromDate}
//                     onChange={(e) => setFromDate(e.target.value)}
//                   />
//                 </div>

//                 <div className="input-fields">
//                   <input
//                     type="date"
//                     style={{ border: "none", opacity: "0.7" }}
//                     value={toDate}
//                     onChange={(e) => setToDate(e.target.value)}
//                   />
//                 </div>

//                 <Col lg={2} xs={12}>
//                   <Select
//                     isMulti
//                     options={branchOptions}
//                     placeholder="Select Branches"
//                     value={selectedBranches}
//                     onChange={setSelectedBranches}
//                     className=""
//                   />
//                 </Col>
//                 <Col lg={2} xs={12}>
//                   <Select
//                     isMulti
//                     options={croOptions}
//                     placeholder="Select Cro's"
//                     value={selectedCros}
//                     onChange={setSelectedCros}
//                     className=""
//                   />
//                 </Col>
//                 <Col lg={3} xs={10}>
//                   <InputGroup>
//                     <FormControl
//                       style={{ backgroundColor: "transparent" }}
//                       placeholder="Name/ApplicationId"
//                       value={searchTerm}
//                       onChange={(e) => setSearchTerm(e.target.value)}
//                     />
//                     <InputGroup.Text style={{ backgroundColor: "transparent" }}>
//                       <FiSearch style={{ color: "a3a3a3" }} />
//                     </InputGroup.Text>
//                   </InputGroup>
//                 </Col>
//               </div>
//             </div>

//             <div
//               style={{
//                 display: "flex",
//                 flexWrap: "wrap",
//                 gap: "8px",
//                 padding: "16px",
//                 height: "78%",
//                 overflowY: "scroll",
//                 scrollbarWidth: "none",
//               }}
//             >
//               {currentItems.length > 0 ? (
//                 currentItems.map((member) => (
//                   <div
//                     key={member.member_id}
//                     style={{
//                       borderRadius: "5px",
//                       padding: "16px",
//                       width: "100%",
//                       boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
//                       justifyContent: "space-between",
//                       alignItems: "center",
//                       marginBottom: "15px",
//                     }}
//                   >
//                     <div>
//                       {adminUser.userType === "developer" && (
//                         <div className="d-flex align-items-center mx-2">
//                           <Button
//                             className="btn btn-danger"
//                             onClick={() => handleDelMember(member.id)}
//                           >
//                             Delete
//                           </Button>
//                         </div>
//                       )}

//                       <div style={{ display: "flex" }}>
//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "center",
//                             marginBottom: "5px",
//                             width: "35%",
//                           }}
//                         >
//                           <Zoom>
//                             <img
//                               src={`${BASE_URL}/images/${member.memberPhoto}`}
//                               width={60}
//                               height={60}
//                               alt="Member"
//                               style={{
//                                 borderRadius: "5px",
//                                 marginRight: "10px",
//                               }}
//                             />
//                           </Zoom>
//                           <div style={{ textAlign: "left" }}>
//                             <div>{member.memberName}</div>
//                             <div>Prospect ID: {member.ApplicationId}</div>
//                             {adminUser.userType === "Branch Manager" &&
//                               filterStatus === "approved" && (
//                                 <div>{member.branchManagerStatus}</div>
//                               )}
//                             {adminUser.userType === "MIS" &&
//                               filterStatus === "approved" && (
//                                 <div>{member.misStatus}</div>
//                               )}
//                           </div>
//                         </div>
//                         <div style={{ marginBottom: "8px", width: "20%" }}>
//                           <MdDateRange
//                             style={{
//                               marginRight: "5px",
//                               fontSize: "37px",
//                               padding: "10px",
//                               borderRadius: "5px",
//                               backgroundColor: "#100D4020",
//                               color: "#181818",
//                             }}
//                           />
//                           {new Date(member.createdAt).toLocaleDateString(
//                             "en-US",
//                             {
//                               year: "numeric",
//                               month: "2-digit",
//                               day: "2-digit",
//                             }
//                           )}
//                         </div>
//                         <div style={{ marginBottom: "8px", width: "20%" }}>
//                           <FaLocationDot
//                             style={{
//                               marginRight: "5px",
//                               fontSize: "35px",
//                               padding: "10px",
//                               borderRadius: "5px",
//                               backgroundColor: "#100D4020",
//                               color: "#181818",
//                             }}
//                           />
//                           {member.branchName}
//                         </div>
//                         <div style={{ marginBottom: "8px", width: "20%" }}>
//                           CRO: {member.croName}
//                         </div>
//                         <div style={{ marginBottom: "8px", width: "20%" }}>
//                           Loan Amount: Rs.
//                           {member.loanType === "Business Loan"
//                             ? member.sanctionedLoanAmountBySanctionCommittee ??
//                               member.proposedLoanAmount
//                             : member.loanType === "GP Loan"
//                             ? member.totalLoanAmountByBm ??
//                               member.proposedLoanAmount
//                             : member.proposedLoanAmount}
//                         </div>
//                         <div style={{ width: "15%" }}>
//                           <Dropdown>
//                             <Dropdown.Toggle
//                               variant="secondary"
//                               id="dropdown-basic"
//                               style={{
//                                 backgroundColor: "#d4d4d8",
//                                 border: "none",
//                                 color: "#181818",
//                                 fontSize: "15px",
//                                 outline: "none",
//                               }}
//                             ></Dropdown.Toggle>

//                             <Dropdown.Menu style={{ padding: "10px" }}>
//                               <div style={{ display: "flex", gap: "10px" }}>
//                                 <Dropdown.Item
//                                   key="empty"
//                                   className="p-0"
//                                 ></Dropdown.Item>

//                                 {[
//                                   "Branch Manager",
//                                   "Credit Manager",
//                                   "MIS",
//                                   "Sanction Committee",
//                                   "Accounts Manager",
//                                   "superadmin",
//                                   "developer",
//                                 ].includes(adminUser.userType) &&
//                                   member.cbReport && (
//                                     <Dropdown.Item
//                                       key={member.cbReport}
//                                       className="p-0"
//                                     >
//                                       <Button
//                                         variant="primary"
//                                         onClick={() =>
//                                           window.open(
//                                             `${BASE_URL}/images/${member.cbReport}`,
//                                             "_blank"
//                                           )
//                                         }
//                                       >
//                                         <IoDocumentTextOutline />
//                                       </Button>
//                                     </Dropdown.Item>
//                                   )}

//                                 {[
//                                   "Branch Manager",
//                                   "Credit Manager",
//                                   "MIS",
//                                   "Sanction Committee",
//                                   "Accounts Manager",
//                                   "superadmin",
//                                   "developer",
//                                 ].includes(adminUser.userType) &&
//                                   member.coApplicantCbReport && (
//                                     <Dropdown.Item
//                                       key={member.coApplicantCbReport}
//                                       className="p-0"
//                                     >
//                                       <Button
//                                         variant="primary"
//                                         onClick={() =>
//                                           window.open(
//                                             `${BASE_URL}/images/${member.coApplicantCbReport}`,
//                                             "_blank"
//                                           )
//                                         }
//                                       >
//                                         <IoDocumentTextOutline />
//                                       </Button>
//                                     </Dropdown.Item>
//                                   )}

//                                 {[
//                                   "Branch Manager",
//                                   "Credit Manager",
//                                   "MIS",
//                                   "Sanction Committee",
//                                   "Accounts Manager",
//                                   "superadmin",
//                                   "developer",
//                                 ].includes(adminUser.userType) &&
//                                   member.pdf1 && (
//                                     <Dropdown.Item
//                                       key={member.pdf1}
//                                       className="p-0"
//                                     >
//                                       <Button
//                                         variant="primary"
//                                         onClick={() =>
//                                           window.open(
//                                             `${BASE_URL}/images/${member.pdf1}`,
//                                             "_blank"
//                                           )
//                                         }
//                                       >
//                                         <IoDocumentTextOutline />
//                                       </Button>
//                                     </Dropdown.Item>
//                                   )}

//                                 {[
//                                   "Branch Manager",
//                                   "Credit Manager",
//                                   "MIS",
//                                   "Sanction Committee",
//                                   "Accounts Manager",
//                                   "superadmin",
//                                   "developer",
//                                 ].includes(adminUser.userType) &&
//                                   member.pdf2 && (
//                                     <Dropdown.Item
//                                       key={member.pdf2}
//                                       className="p-0"
//                                     >
//                                       <Button
//                                         variant="primary"
//                                         onClick={() =>
//                                           window.open(
//                                             `${BASE_URL}/images/${member.pdf2}`,
//                                             "_blank"
//                                           )
//                                         }
//                                       >
//                                         <IoDocumentTextOutline />
//                                       </Button>
//                                     </Dropdown.Item>
//                                   )}

//                                 <Dropdown.Item
//                                   key={member.id}
//                                   as="div"
//                                   className="p-0"
//                                 >
//                                   <ActionButtons
//                                     roleId={adminUser.userType}
//                                     item={member}
//                                     updateList={fetchMemberDetails}
//                                     managerId={adminUser.user.id}
//                                     proposedLoanAmount={
//                                       member.proposedLoanAmount ?? 0
//                                     }
//                                     rateOfInterest={
//                                       member.proposedLoanDetails
//                                         ?.rateOfInterest ?? 0
//                                     }
//                                     tenureInMonths={
//                                       member.proposedLoanDetails
//                                         ?.tenureInMonths ?? 0
//                                     }
//                                     emiDateByCRO={
//                                       member.proposedLoanDetails?.emiDate ??
//                                       null
//                                     }
//                                     emiDateByBM={
//                                       member.emiDateByBranchManager ?? null
//                                     }
//                                     fundingAgencyData={member.fundingAgencyData}
//                                     loanType={loanType}
//                                     bookingProcessDetails={
//                                       member.bookingProcessDetails
//                                     }
//                                   />
//                                 </Dropdown.Item>
//                               </div>
//                             </Dropdown.Menu>
//                           </Dropdown>
//                         </div>
//                       </div>

//                       <div
//                         style={{
//                           display: "flex",
//                           gap: "8px",
//                           width: "100%",
//                           borderRadius: "10px",
//                         }}
//                       >
//                         <div
//                           style={{
//                             width: "15%",
//                             display: "flex",
//                             justifyContent: "center",
//                             alignItems: "center",
//                           }}
//                         >
//                           <button
//                             className="view-btn"
//                             onClick={() => handleShowModal(member.id)}
//                           >
//                             View
//                             <GrFormNext style={{ fontSize: "15px" }} />
//                             <GrFormNext
//                               style={{ fontSize: "18px", marginLeft: "-10px" }}
//                             />
//                           </button>
//                         </div>

//                         {/* Progress bar */}
//                         <div
//                           style={{
//                             width: "85%",
//                             display: "flex",
//                             justifyContent: "center",
//                           }}
//                         >
//                           <div className="step-container">
//                             {/* <!-- Progress bar background --> */}
//                             <div className="progress-bar">
//                               <div
//                                 className="progress"
//                                 style={{ width: "35%" }}
//                               ></div>
//                             </div>

//                             {/* <!-- Step items --> */}
//                             <div className="step active">
//                               <FaUser className="num" />
//                               <span className="step-label">CRO</span>
//                             </div>
//                             <div className="step active">
//                               <FaUser className="num" />
//                               <span className="step-label">BM</span>
//                             </div>
//                             <div className="step active">
//                               <FaUser className="num" />
//                               <span className="step-label">CO</span>
//                             </div>
//                             <div className="step active">
//                               <FaUser className="num" />
//                               <span className="step-label">MIS</span>
//                             </div>
//                             <div className="step">
//                               <FaUser className="num" />
//                               <span className="step-label">CM</span>
//                             </div>
//                             <div className="step">
//                               <FaUser className="num" />
//                               <span className="step-label">SAC</span>
//                             </div>
//                             <div className="step">
//                               <FaUser className="num" />
//                               <span className="step-label">BM-2</span>
//                             </div>
//                             <div className="step">
//                               <FaUser className="num" />
//                               <span className="step-label">MIS-2</span>
//                             </div>
//                             <div className="step">
//                               <FaUser className="num" />
//                               <span className="step-label">A/C M</span>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="text-center w-100">
//                   No member data available.
//                 </div>
//               )}
//             </div>

//             {/* Custom Pagination */}
//             <nav
//               className="custom-pagination"
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 height: "8%",
//                 width: "100%",
//                 backgroundColor: "#202020",
//                 fontSize: "14px",
//                 boxShadow: "rgba(100, 100, 111, 0.2) 0px -2px 15px -2px",
//               }}
//             >
//               <button
//                 style={{
//                   marginLeft: "15px",
//                   backgroundColor: "#323232",
//                   padding: "6px 15px",
//                   borderRadius: "6px",
//                   border: "transparent",
//                   color: "#ECEFF1",
//                 }}
//               >
//                 Total Data: {filteredMembers.length}
//               </button>

//               <ul
//                 className="pagination justify-content-end"
//                 style={{
//                   display: "flex",
//                   height: "100%",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   marginRight: "15px",
//                   marginTop: "auto",
//                   marginBottom: "auto",
//                 }}
//               >
//                 <li
//                   key={currentPage - 1}
//                   className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
//                 >
//                   <button
//                     className="prev-btn "
//                     onClick={() => handlePageChange(currentPage - 1)}
//                   >
//                     Previous
//                   </button>
//                 </li>
//                 <li key={currentPage} className="page-item active">
//                   <button
//                     className="page-link"
//                     onClick={() => handlePageChange(currentPage)}
//                   >
//                     Page {currentPage} / {totalPages}
//                   </button>
//                 </li>
//                 <li
//                   key={currentPage + 1}
//                   className={`page-item ${
//                     currentPage === totalPages ? "disabled" : ""
//                   }`}
//                 >
//                   <button
//                     className="prev-btn "
//                     style={{ width: "80px", borderRadius: "0 5px 5px 0" }}
//                     onClick={() => handlePageChange(currentPage + 1)}
//                   >
//                     Next
//                   </button>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         </div>
//       </div>

//       {showModal && (
//         <MemberDetailsModal
//           show={showModal}
//           handleClose={() => setShowModal(false)}
//           memberId={selectedMemberId}
//         />
//       )}

//       <DeleteConfirmationModal
//         showModal={showDelModal}
//         handleClose={() => setShowDelModal(false)}
//         handleSubmitAlert={handleSubmitAlert}
//       />
//     </div>
//   );
// };

// export default MemberDetails;





import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import { useAdminAuth } from "../../auth/AdminAuthProvider";
import { BASE_URL } from "../../../env";
import DashboardHeader from "../../../components/layout/DashboardHeader";
import Sidebar from "../../../components/layout/Sidebar";
import { InputGroup, FormControl, Button, Row, Col } from "react-bootstrap";
import MemberDetailsModal from "../components/MemberDetailsModal";
import { IoSearch, IoDocumentTextOutline } from "react-icons/io5";
import { useLocation } from "react-router-dom";
import ActionButtons from "../../workflows/components/ActionButtons";
import Zoom from "react-medium-image-zoom";
import { MdContentPasteSearch, MdDateRange, MdExpandMore } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import { FaAngleRight, FaUser, FaAngleLeft, FaUsers } from "react-icons/fa";
import { Dropdown } from "react-bootstrap";
import Select from "react-select";
import DeleteConfirmationModal from "../../../components/ui/DeleteConfirmationModal";
import DeveloperDeleteModal from "../../users-management/components/DeveloperDeleteModal";
import { FiSearch } from "react-icons/fi";
import { GrFormNext, GrFormNextLink } from "react-icons/gr";
import "../../dashboard/screens/Pagination.css";
import "../../dashboard/screens/Filters.css";

const MemberDetails = () => {
  const location = useLocation();
  const { filterStatus, loanType: incomingLoanType, loanStyle } = location.state || {};
  const loanType = incomingLoanType || "Business Loan";
  const { adminUser, openSidebarToggle, toggleSidebar } = useAdminAuth();

  // Guards fetchMemberDetails against a stale response. Clicking quickly
  // between two sidebar sections (e.g. GP Loan Rejected, then DL Pending)
  // starts a new request before the old one has resolved; nothing here used
  // to check whether a response still matched what was currently being
  // asked for, so a slow, earlier request could resolve LAST and overwrite
  // the correct, newer list - including with an empty one, since the older
  // request's own loanType/filterStatus never matched what's now on screen.
  // Bumped at the start of every fetch; a response is applied only if it is
  // still the most recent request made.
  const fetchRequestIdRef = useRef(0);

  const [searchTerm, setSearchTerm] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [selectedCros, setSelectedCros] = useState([]);
  const [memberData, setMemberData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [showDelModal, setShowDelModal] = useState(false);
  const [showDevDelModal, setShowDevDelModal] = useState(false);
  const [showMobileFilters, setShowMobileFilters] = useState(false);

  const OpenSidebar = () => {
    toggleSidebar();
  };

  // Extract unique branches for the select options - Remove duplicates, null, undefined, empty values
  const branchOptions = [
    ...new Set(
      memberData
        .map((member) => member.branchName)
        .filter((branch) => branch && branch.trim() !== "")
    ),
  ].map((branch) => ({
    label: branch,
    value: branch,
  }));

  const croOptions = [
    ...new Set(
      memberData
        .map((member) => member.croName)
        .filter((cro) => cro && cro.trim() !== "")
    ),
  ].map((cro) => ({
    label: cro,
    value: cro,
  }));


  const fetchMemberDetails = useCallback(async () => {
    const requestId = ++fetchRequestIdRef.current;
    try {
      const params = {};
      let getMemberDetails = "";
      params.loanType = loanType || "";
      if (
        loanType === "Business Loan" &&
        adminUser.userType === "Branch Manager"
      ) {
        getMemberDetails = "getMemberDetailsByBranchManager";
        params.branchManagerId = adminUser.user.id;
        if (filterStatus === "approved") {
          params.branchManagerStatus = ["submitted", "disbursed"];
        }
        if (filterStatus === "pending") {
          params.branchManagerStatus = "pending";
          params.fieldManagerStatus = "submitted";
        }
        if (filterStatus === "retrigger") {
          params.branchManagerStatus = "retrigger";
          params.creditOfficerStatus = "pending"; // Stage 1 Retrigger
        }
        if (filterStatus === "disbursed") {
          params.fieldManagerStatus = "submitted";
          params.branchManagerStatus = ["submitted", "retrigger"]; // Stage 1 submitted OR Stage 2 Retrigger
          params.creditOfficerStatus = "submitted";
          params.misStatus = "submitted";
          params.creditManagerStatus = "submitted";
          params.sanctionCommitteeStatus = "approved";
          params.accountManagerStatus = "pending";
        }
        if (filterStatus === "rejected") {
          params.branchManagerStatus = "rejected";
        }
      }
      if (
        loanType === "Business Loan" &&
        adminUser.userType === "Credit Officer"
      ) {
        getMemberDetails = "getMemberDetailsByCreditOfficer";
        params.creditOfficerId = adminUser.user.id;
        if (filterStatus === "approved") {
          params.creditOfficerStatus = "submitted";
        }
        if (filterStatus === "pending") {
          params.creditOfficerStatus = "pending";
          params.branchManagerStatus = "submitted";
        }
        if (filterStatus === "retrigger") {
          params.creditOfficerStatus = "retrigger";
        }
        if (filterStatus === "rejected") {
          params.creditOfficerStatus = "rejected";
        }
      }
      if (loanType === "Business Loan" && adminUser.userType === "MIS") {
        getMemberDetails = "getMemberDetailsByMis";
        params.misId = adminUser.user.id;
        if (filterStatus === "approved") {
          params.misStatus = ["submitted", "disbursed"];
        }
        if (filterStatus === "pending") {
          params.misStatus = "pending";
          params.creditOfficerStatus = "submitted";
        }
        if (filterStatus === "retrigger") {
          params.misStatus = "retrigger";
        }
        if (filterStatus === "disbursed") {
          params.fieldManagerStatus = "submitted";
          params.branchManagerStatus = "disbursed";
          params.creditOfficerStatus = "submitted";
          params.misStatus = "submitted";
          params.creditManagerStatus = "submitted";
          params.sanctionCommitteeStatus = "approved";
          params.accountManagerStatus = "pending";
        }
        if (filterStatus === "rejected") {
          params.misStatus = "rejected";
        }
      }
      if (
        loanType === "Business Loan" &&
        adminUser.userType === "Credit Manager"
      ) {
        getMemberDetails = "getMemberDetailsByCreditManager";
        params.creditManagerId = adminUser.user.id;
        if (filterStatus === "approved") {
          params.creditManagerStatus = "submitted";
        }
        if (filterStatus === "pending") {
          params.creditManagerStatus = "pending";
          params.misStatus = "submitted";
        }
        if (filterStatus === "retrigger") {
          params.creditManagerStatus = "retrigger";
        }
        if (filterStatus === "rejected") {
          params.creditManagerStatus = "rejected";
        }
      }
      if (
        loanType === "Business Loan" &&
        adminUser.userType === "Sanction Committee"
      ) {
        getMemberDetails = "getMemberDetailsBySanctionCommittee";
        params.sanctionCommitteeId = adminUser.user.id;
        if (filterStatus === "approved") {
          params.sanctionCommitteeStatus = "approved";
        }
        if (filterStatus === "pending") {
          params.sanctionCommitteeStatus = "pending";
          params.creditManagerStatus = "submitted";
        }
        if (filterStatus === "retrigger") {
          params.sanctionCommitteeStatus = "retrigger";
        }
        if (filterStatus === "rejected") {
          params.sanctionCommitteeStatus = "rejected";
        }
      }
      // Daily Loan has no MIS or Credit Manager stage, and reaches the
      // Sanction Committee straight from the Credit Officer - the Business
      // Loan block above requires creditManagerStatus === "submitted", which
      // a Daily Loan never sets, so without this block every DL loan was
      // invisible to the Sanction Committee (this whole function had no
      // Daily Loan branch at all, for any role). Matches the button
      // visibility condition already in ActionButtons.js.
      if (
        loanType === "Daily Loan" &&
        adminUser.userType === "Credit Officer"
      ) {
        getMemberDetails = "getMemberDetailsByCreditOfficer";
        params.creditOfficerId = adminUser.user.id;
        if (filterStatus === "approved") {
          params.creditOfficerStatus = "submitted";
        }
        if (filterStatus === "pending") {
          params.creditOfficerStatus = "pending";
          params.fieldManagerStatus = "submitted";
        }
        if (filterStatus === "retrigger") {
          params.creditOfficerStatus = "retrigger";
        }
        if (filterStatus === "rejected") {
          params.creditOfficerStatus = "rejected";
        }
      }
      if (
        loanType === "Daily Loan" &&
        adminUser.userType === "Sanction Committee"
      ) {
        getMemberDetails = "getMemberDetailsBySanctionCommittee";
        params.sanctionCommitteeId = adminUser.user.id;
        if (filterStatus === "approved") {
          params.sanctionCommitteeStatus = "approved";
        }
        if (filterStatus === "pending") {
          params.sanctionCommitteeStatus = "pending";
          params.creditOfficerStatus = "submitted";
        }
        if (filterStatus === "retrigger") {
          params.sanctionCommitteeStatus = "retrigger";
        }
        if (filterStatus === "rejected") {
          params.sanctionCommitteeStatus = "rejected";
        }
      }
      if (
        loanType === "Daily Loan" &&
        adminUser.userType === "Branch Manager"
      ) {
        getMemberDetails = "getMemberDetailsByBranchManager";
        params.branchManagerId = adminUser.user.id;
        if (filterStatus === "approved") {
          params.sanctionCommitteeStatus = "approved";
        }
        if (filterStatus === "pending") {
          params.sanctionCommitteeStatus = "approved";
          params.branchManagerStatus = "pending";
        }
        if (filterStatus === "disbursed") {
          params.branchManagerStatus = "disbursed";
        }
        if (filterStatus === "retrigger") {
          params.branchManagerStatus = "retrigger";
        }
        if (filterStatus === "rejected") {
          params.branchManagerStatus = "rejected";
        }
      }
      if (
        loanType === "Business Loan" &&
        adminUser.userType === "Accounts Manager"
      ) {
        getMemberDetails = "getMemberDetailsByAccountsManager";
        params.accountManagerId = adminUser.user.id;
        if (filterStatus === "approved") {
          params.accountManagerStatus = "payment credited";
        }
        if (filterStatus === "pending") {
          params.accountManagerStatus = "pending";
          params.misStatus = "disbursed";
        }
        if (filterStatus === "retrigger") {
          params.accountManagerStatus = "retrigger";
        }
      }
      // Daily Loan has no MIS stage; the Branch Manager disburses the loan
      // immediately before the Accounts Manager pays it, so that is the
      // adjacency check here instead of misStatus === "disbursed". Matches
      // the Accounts Manager button condition in ActionButtons.js.
      if (
        loanType === "Daily Loan" &&
        adminUser.userType === "Accounts Manager"
      ) {
        getMemberDetails = "getMemberDetailsByAccountsManager";
        params.accountManagerId = adminUser.user.id;
        if (filterStatus === "approved") {
          params.accountManagerStatus = "payment credited";
        }
        if (filterStatus === "pending") {
          params.accountManagerStatus = "pending";
          params.branchManagerStatus = "disbursed";
        }
        if (filterStatus === "retrigger") {
          params.accountManagerStatus = "retrigger";
        }
      }
      if (loanType === "GP Loan" && adminUser.userType === "MIS") {
        getMemberDetails = "getMemberDetailsByMis";
        params.misId = adminUser.user.id;
        if (filterStatus === "approved") {
          params.misStatus = ["submitted", "orderPlaced", "recheckFinally"];
        }
        if (filterStatus === "pending") {
          params.misStatus = "pending";
          params.branchManagerStatus = "submitted";
        }
        if (filterStatus === "retrigger") {
          params.misStatus = ["retrigger", "retrigger_stage2"];
        }
        if (filterStatus === "orderPlaced") {
          params.fieldManagerStatus = "submitted";
          params.misStatus = "pending";
          params.branchManagerStatus = "submitted";
        }
        if (filterStatus === "recheckFinally") {
          params.fieldManagerStatus = "submitted";
          params.creditManagerStatus = "submitted";
          params.misStatus = "orderPlaced";
          params.branchManagerStatus = "disbursed";
          params.accountManagerStatus = "pending";
        }
        if (filterStatus === "rejected") {
          // No specific param needed, frontend will filter all rejections
        }
      }
      if (loanType === "GP Loan" && adminUser.userType === "Credit Manager") {
        getMemberDetails = "getMemberDetailsByCreditManager";
        params.creditManagerId = adminUser.user.id;
        if (filterStatus === "approved") {
          params.creditManagerStatus = "submitted";
        }
        if (filterStatus === "pending") {
          params.creditManagerStatus = "pending";
          params.misStatus = "orderPlaced";
        }
        if (filterStatus === "retrigger") {
          params.creditManagerStatus = "retrigger";
        }
        if (filterStatus === "rejected") {
          // No specific param needed, frontend will filter all rejections
        }
      }

      if (loanType === "GP Loan" && adminUser.userType === "Branch Manager") {
        getMemberDetails = "getMemberDetailsByBranchManager";
        params.branchManagerId = adminUser.user.id;
        if (filterStatus === "approved") {
          params.branchManagerStatus = ["submitted", "disbursed"];
        }
        if (filterStatus === "pending") {
          params.branchManagerStatus = "pending";
          params.fieldManagerStatus = "submitted";
        }
        if (filterStatus === "retrigger") {
          params.branchManagerStatus = "retrigger";
        }
        if (filterStatus === "disbursed") {
          params.fieldManagerStatus = "submitted";
          params.creditManagerStatus = "submitted";
          params.branchManagerStatus = "submitted";
          params.misStatus = "orderPlaced";
          params.accountManagerStatus = "pending";
        }
        if (filterStatus === "rejected") {
          // No specific param needed, frontend will filter all rejections
        }
      }
      if (loanType === "GP Loan" && adminUser.userType === "Accounts Manager") {
        getMemberDetails = "getMemberDetailsByAccountsManager";
        params.accountManagerId = adminUser.user.id;
        if (filterStatus === "approved") {
          params.accountManagerStatus = "payment credited";
        }
        if (filterStatus === "pending") {
          params.accountManagerStatus = "pending";
          params.misStatus = "recheckFinally";
        }
        if (filterStatus === "retrigger") {
          params.accountManagerStatus = "retrigger";
        }
      }
      // GP Loan's own route skips Credit Officer and Sanction Committee
      // entirely (CRO -> BM -> MIS -> Credit Manager -> AM), so Sanction
      // Committee has no action of its own here and no status column of its
      // own is ever set on a GPL loan. The Approved/Pending/Retrigger/
      // Rejected menu items are shown to every role regardless, so rather
      // than hide GPL from Sanction Committee this gives them the same
      // read-only oversight they already have of Business Loan and Daily
      // Loan - every GPL loan in their branches, filtered below using GPL's
      // own progress columns instead of sanctionCommitteeStatus. No status
      // param is set here on purpose: the split into pending/approved/
      // rejected/retrigger happens after the fetch, not at the API.
      // ActionButtons.js never gates a GP Loan button on "Sanction
      // Committee", so nothing here lets them act on what they can see.
      if (loanType === "GP Loan" && adminUser.userType === "Sanction Committee") {
        getMemberDetails = "getMemberDetailsBySanctionCommittee";
        params.sanctionCommitteeId = adminUser.user.id;
      }

      if (
        adminUser.userType === "superadmin" ||
        adminUser.userType === "developer"
      ) {
        getMemberDetails = "getMemberDetailsBySuperadmin";
        params.superadminId = adminUser.user.id;
        if (filterStatus === "approved") {
          params.accountManagerStatus = "payment credited";
        }
      }
      const response = await axios.get(`${BASE_URL}/api/${getMemberDetails}`, {
        params,
      });
      // Helper function to remove duplicates based on member ID
      const removeDuplicates = (dataList) => {
        const seen = new Map();
        return dataList.filter((member) => {
          // Use member.id as the unique identifier
          const memberId = member.id || member.member_id || member.ApplicationId;
          if (!memberId || seen.has(memberId)) {
            return false;
          }
          seen.set(memberId, true);
          return true;
        });
      };

      let finalData = response.data.list;

      if (filterStatus === "rejected") {
        finalData = finalData.filter((member) =>
          [
            "branchManagerStatus",
            "creditOfficerStatus",
            "misStatus",
            "creditManagerStatus",
            "sanctionCommitteeStatus",
            "accountManagerStatus",
          ].some((status) => member[status] === "rejected")
        );
      } else if (filterStatus === "approved" || filterStatus === "pending" || filterStatus === "retrigger" || filterStatus === "orderPlaced" || filterStatus === "recheckFinally" || filterStatus === "disbursed" || filterStatus === "" || !filterStatus) {
        // For all active/pending views, exclude rejected loans
        finalData = finalData.filter((member) => {
          const isRejected = [
            "branchManagerStatus",
            "creditOfficerStatus",
            "misStatus",
            "creditManagerStatus",
            "sanctionCommitteeStatus",
            "accountManagerStatus",
          ].some((status) => member[status] === "rejected");

          if (isRejected) return false;

          // GP Loan specific filters to ensure items hide after action
          if (loanType === "GP Loan" && adminUser.userType !== "superadmin" && adminUser.userType !== "developer") {
            if (adminUser.userType === "MIS") {
              if (filterStatus === "pending") return false; // Hide Pending list for MIS1
              if (filterStatus === "orderPlaced") return member.misStatus === "pending" && member.branchManagerStatus === "submitted"; // MIS1 shows in Order Placed
              if (filterStatus === "recheckFinally") return member.misStatus === "orderPlaced" && member.branchManagerStatus === "disbursed";
            }
            if (adminUser.userType === "Branch Manager") {
              if (filterStatus === "pending") return member.branchManagerStatus === "pending";
              if (filterStatus === "disbursed") return member.branchManagerStatus === "submitted";
            }
            if (adminUser.userType === "Credit Manager") {
              if (filterStatus === "pending") return member.creditManagerStatus === "pending";
            }
            if (adminUser.userType === "Accounts Manager") {
              if (filterStatus === "pending") return member.accountManagerStatus === "pending";
            }
            if (adminUser.userType === "Sanction Committee") {
              // Read-only oversight - Sanction Committee has no status
              // column of its own on a GPL loan, so these buckets read GPL's
              // own progress instead: fully paid counts as approved,
              // anything else still in flight counts as pending, and
              // retrigger looks across every stage GPL actually has, the
              // same way the generic "rejected" check above already does.
              if (filterStatus === "pending") {
                return member.accountManagerStatus !== "payment credited";
              }
              if (filterStatus === "approved") {
                return member.accountManagerStatus === "payment credited";
              }
              if (filterStatus === "retrigger") {
                return [
                  "branchManagerStatus",
                  "misStatus",
                  "creditManagerStatus",
                  "accountManagerStatus",
                ].some((status) => {
                  const s = (member[status] || "").toString().toLowerCase().trim();
                  return s === "retrigger" || s === "retrigger_stage2";
                });
              }
            }
          }

          // Special case for superadmin pending view: must also be pending for accounts manager
          if ((adminUser.userType === "superadmin" || adminUser.userType === "developer") && filterStatus === "pending") {
            return member.accountManagerStatus === "pending";
          }

          return true;
        });
      }

      // Ignore this response if a newer request has been made since - it
      // belongs to whatever loanType/filterStatus was selected before this
      // one, and applying it now would overwrite the list currently on
      // screen with data for the wrong section.
      if (requestId !== fetchRequestIdRef.current) {
        return;
      }
      setMemberData(removeDuplicates(finalData));
    } catch (error) {
      if (requestId !== fetchRequestIdRef.current) {
        return;
      }
      console.error("Error fetching member details:", error);
    }
  }, [adminUser.user.id, adminUser.userType, filterStatus, loanType]);

  useEffect(() => {
    fetchMemberDetails();
  }, [fetchMemberDetails]);

  const filteredMembers = memberData.filter((member) => {
    // Normalize the searchTerm
    const normalizedSearchTerm = searchTerm.toLowerCase();

    // Parse `fromDate` and `toDate` into comparable Date objects
    const fromDateObj = fromDate ? new Date(fromDate) : null;
    const toDateObj = toDate ? new Date(toDate) : null;

    // Check if the searchTerm matches text fields
    const matchesTextFields =
      member.memberName.toLowerCase().includes(normalizedSearchTerm) ||
      member.ApplicationId.toLowerCase().includes(normalizedSearchTerm);

    // Check if the memberCreatedAt falls within the date range
    const createdAtDateObj = new Date(
      member.createdAt // Raw date for comparison
    );

    // Normalize both createdAt and toDate to only consider the date portion (ignore time)
    const isSameDateOrBefore = (date1, date2) => {
      return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
      );
    };

    const matchesDateRange =
      (!fromDateObj || createdAtDateObj >= fromDateObj) &&
      (!toDateObj ||
        createdAtDateObj <= toDateObj ||
        isSameDateOrBefore(createdAtDateObj, toDateObj));

    // Check if the member's branch matches the selected branches
    const matchesBranch =
      selectedBranches.length === 0 ||
      selectedBranches.some((branch) => branch.value === member.branchName);

    // Check if the member's croName matches the selected cro's
    const matchesCro =
      selectedCros.length === 0 ||
      selectedCros.some((cro) => cro.value === member.croName);

    // Return true if text fields, date range,branches and cro's match
    return matchesTextFields && matchesDateRange && matchesBranch && matchesCro;
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredMembers.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filteredMembers.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleShowModal = (memberId) => {
    setSelectedMemberId(memberId);
    setShowModal(true);
  };

  const handleDelMember = (memberId) => {
    console.log("setSelectedMemberId: " + memberId);
    setSelectedMemberId(memberId);
    if (adminUser.userType === "developer") {
      setShowDevDelModal(true);
    } else {
      setShowDelModal(true);
    }
  };

  const handleSubmitAlert = useCallback(
    async (event) => {
      event.preventDefault();
      const clickedButton = event.nativeEvent.submitter;
      const buttonValue = clickedButton.getAttribute("name");

      if (buttonValue === "Yes") {
        console.log("Yes button clicked ");
        console.log("Selected memberId: " + selectedMemberId);
        try {
          const res = await axios.post(`${BASE_URL}/api/delMember`, {
            memberId: selectedMemberId,
          });
          if (res.data.message) {
            console.log("Deleted Successfully: " + selectedMemberId);
          } else if (res.data.error) {
            console.log("error from api: " + res.data.error);
          }
        } catch (error) {
          console.log("error in catch: " + error);
        } finally {
          fetchMemberDetails();
          setShowDelModal(false);
        }
      } else if (buttonValue === "No") {
        console.log("No button clicked ");
        setShowDelModal(false);
      }
    },
    [selectedMemberId, fetchMemberDetails]
  );

  const getStepStatus = (member) => {
    const isGPL = member.loanType?.toString().toLowerCase().trim() === "gp loan";
    const isBL = member.loanType?.toString().toLowerCase().trim() === "business loan";
    const isDL = member.loanType?.toString().toLowerCase().trim() === "daily loan";
    const normalizedStatus = (val) => (val || "").toString().toLowerCase().trim();
    const hasValue = (val) => val && val !== "pending" && val !== null && val !== "";


    const isRejectedOverall = [
      "branchManagerStatus",
      "creditOfficerStatus",
      "misStatus",
      "creditManagerStatus",
      "sanctionCommitteeStatus",
      "accountManagerStatus",
    ].some((status) => normalizedStatus(member[status]) === "rejected");

    const isRetriggerOverall = [
      "fieldManagerStatus",
      "branchManagerStatus",
      "creditOfficerStatus",
      "misStatus",
      "creditManagerStatus",
      "sanctionCommitteeStatus",
    ].some((status) => {
      const s = normalizedStatus(member[status]);
      return s === "retrigger" || s === "retriggertoeditbankdetails";
    });

    const getStatus = (label) => {
      const fmS = normalizedStatus(member.fieldManagerStatus);
      const bmS = normalizedStatus(member.branchManagerStatus);
      const coS = normalizedStatus(member.creditOfficerStatus);
      const misS = normalizedStatus(member.misStatus);
      const cmS = normalizedStatus(member.creditManagerStatus);
      const sacS = normalizedStatus(member.sanctionCommitteeStatus);
      const acmS = normalizedStatus(member.accountManagerStatus);

      switch (label) {
        case "CRO":
          if (fmS === "retrigger" || fmS === "retriggertoeditbankdetails") return "retrigger";
          return "submitted";
        case "BM":
          if (bmS === "rejected") return "rejected";
          if (isGPL && ["orderplaced", "recheckfinally", "disbursed"].includes(misS)) return "submitted";
          return bmS;
        case "CO": return coS;
        case "MIS":
          if (misS === "rejected") return "rejected";
          if (isGPL && hasValue(cmS) && cmS !== "rejected") return "orderplaced";
          return misS;
        case "CM": return cmS;
        case "SAC": return sacS;
        case "BM-2":
          if (bmS === "rejected") return "rejected";
          if (bmS === "disbursed") return "disbursed";
          if (isGPL && bmS === "retrigger") return "retrigger";
          return "pending";
        case "MIS-2":
          if (misS === "rejected") return "rejected";
          if (misS === "disbursed" || misS === "recheckfinally") return "disbursed";
          if (isGPL && misS === "retrigger") return "retrigger";
          return "pending";
        case "A/C M": return acmS;
        default: return "pending";
      }
    };



    const isGPLDone = {
      cro: normalizedStatus(member.fieldManagerStatus) === "submitted",
      bm: ["submitted", "disbursed"].includes(normalizedStatus(member.branchManagerStatus)),
      mis: ["orderplaced", "recheckfinally", "disbursed"].includes(normalizedStatus(member.misStatus)),
      cm: normalizedStatus(member.creditManagerStatus) === "submitted",
      bm2: normalizedStatus(member.branchManagerStatus) === "disbursed",
      mis2: ["recheckfinally", "disbursed"].includes(normalizedStatus(member.misStatus)),
      acm: normalizedStatus(member.accountManagerStatus) === "payment credited"
    };

    const isBLDone = {
      cro: normalizedStatus(member.fieldManagerStatus) === "submitted",
      bm: ["submitted", "disbursed"].includes(normalizedStatus(member.branchManagerStatus)),
      co: normalizedStatus(member.creditOfficerStatus) === "submitted",
      mis: ["submitted", "disbursed"].includes(normalizedStatus(member.misStatus)),
      cm: normalizedStatus(member.creditManagerStatus) === "submitted",
      sac: normalizedStatus(member.sanctionCommitteeStatus) === "approved",
      bm2: normalizedStatus(member.branchManagerStatus) === "disbursed",
      mis2: normalizedStatus(member.misStatus) === "disbursed",
      acm: normalizedStatus(member.accountManagerStatus) === "payment credited"
    };

    // Daily Loan has no MIS or Credit Manager stage, and its Branch Manager
    // acts AFTER the Sanction Committee (disbursing), not before it like BL
    // and GPL. There is no stage-2 loop either - a DL loan is never sent
    // through any stage twice. So it gets its own five-step list, in its own
    // order, rather than falling into the nine-step Business Loan list
    // below, which is what showed MIS/CM/SAC/BM-2/MIS-2 for a product that
    // has none of them.
    const isDLDone = {
      cro: normalizedStatus(member.fieldManagerStatus) === "submitted",
      co: normalizedStatus(member.creditOfficerStatus) === "submitted",
      sac: normalizedStatus(member.sanctionCommitteeStatus) === "approved",
      bm: ["submitted", "disbursed"].includes(normalizedStatus(member.branchManagerStatus)),
      acm: normalizedStatus(member.accountManagerStatus) === "payment credited",
    };

    const stepsRaw = isGPL ? [
      { label: "CRO", isStepDone: isGPLDone.cro },
      { label: "BM", isStepDone: isGPLDone.bm },
      { label: "MIS", isStepDone: isGPLDone.mis },
      { label: "CM", isStepDone: isGPLDone.cm },
      { label: "BM-2", isStepDone: isGPLDone.bm2 },
      { label: "MIS-2", isStepDone: isGPLDone.mis2 },
      { label: "A/C M", isStepDone: isGPLDone.acm },
    ] : isDL ? [
      { label: "CRO", isStepDone: isDLDone.cro },
      { label: "CO", isStepDone: isDLDone.co },
      { label: "SAC", isStepDone: isDLDone.sac },
      { label: "BM", isStepDone: isDLDone.bm },
      { label: "A/C M", isStepDone: isDLDone.acm },
    ] : [
      { label: "CRO", isStepDone: isBLDone.cro },
      { label: "BM", isStepDone: isBLDone.bm },
      { label: "CO", isStepDone: isBLDone.co },
      { label: "MIS", isStepDone: isBLDone.mis },
      { label: "CM", isStepDone: isBLDone.cm },
      { label: "SAC", isStepDone: isBLDone.sac },
      { label: "BM-2", isStepDone: isBLDone.bm2 },
      { label: "MIS-2", isStepDone: isBLDone.mis2 },
      { label: "A/C M", isStepDone: isBLDone.acm },
    ];


    let hasRejectionOccurred = false;
    let sequentialReached = true;
    const processedSteps = stepsRaw.map((step) => {
      const status = getStatus(step.label);
      let isReached = sequentialReached && !hasRejectionOccurred;

      if (status === "rejected") {
        hasRejectionOccurred = true;
      }

      const isActuallyDone = step.isStepDone;

      // Update sequentialReached for the NEXT step: 
      // It remains true ONLY if the current step is reached AND it is done.
      if (!isReached || !isActuallyDone) {
        sequentialReached = false;
      }

      return { ...step, isReached, status, isActuallyDone };
    });

    let lastActiveIndex = 0;
    processedSteps.forEach((step, index) => {
      if (step.isReached) {
        lastActiveIndex = index;
      }
    });

    if (normalizedStatus(member.accountManagerStatus) === "payment credited") {
      lastActiveIndex = processedSteps.length - 1;
    }

    const progressWidth = (lastActiveIndex / (processedSteps.length - 1)) * 100;

    return {
      steps: processedSteps.map((step) => {
        const s = normalizedStatus(step.status);
        let color = "#bfc3c9"; // Grey (Future)
        if (step.isReached) {
          if (s === "rejected") {
            color = "red";
          } else if (s === "retrigger" || s === "retriggertoeditbankdetails") {
            color = "#ffc107"; // Yellow only for retrigger
          } else {
            color = "green"; // Both Completed and Active-Pending are Green
          }
        }

        return {
          ...step,
          active: step.isReached,
          color: color,
        };
      }),
      progressWidth,
      progressColor: isRejectedOverall ? "red" : (isRetriggerOverall ? "#ffc107" : "green"),
    };
  };

  return (
    <section className="master-layout">
      <div className="master-sidebar-wrapper">
        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
      </div>

      <div className="master-content-wrapper">
        <div className="master-header-wrapper">
          <DashboardHeader OpenSidebar={OpenSidebar} />
        </div>

        <div className="master-card-container" style={{ overflow: "hidden" }}>
          <div
            className="member-details"
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              borderRadius: "inherit",
              backgroundColor: "white",
              minHeight: 0,
              overflow: "hidden",
            }}
          >
            <div className="filters-wrapper">
              <button
                className={`filter-toggle-btn ${showMobileFilters ? 'active' : ''}`}
                onClick={() => setShowMobileFilters(!showMobileFilters)}
              >
                <span>{showMobileFilters ? 'Hide Filters' : 'Show Filters'}</span>
                <MdExpandMore size={24} />
              </button>

              <div className={`filter-container ${showMobileFilters ? 'is-visible' : ''}`}>
                <div className="date-input-group">
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => {
                      const val = e.target.value;
                      setFromDate(val);
                      if (val && toDate && selectedBranches.length > 0 && selectedCros.length > 0) {
                        setTimeout(() => setShowMobileFilters(false), 300);
                      }
                    }}
                    title="From Date"
                  />
                </div>

                <div className="date-input-group">
                  <input
                    type="date"
                    value={toDate}
                    onChange={(e) => {
                      const val = e.target.value;
                      setToDate(val);
                      if (fromDate && val && selectedBranches.length > 0 && selectedCros.length > 0) {
                        setTimeout(() => setShowMobileFilters(false), 300);
                      }
                    }}
                    title="To Date"
                  />
                </div>

                <Select
                  isMulti
                  options={branchOptions}
                  placeholder="Select Branches"
                  value={selectedBranches}
                  onChange={(val) => {
                    setSelectedBranches(val);
                    if (fromDate && toDate && val && val.length > 0 && selectedCros.length > 0) {
                      setTimeout(() => setShowMobileFilters(false), 300);
                    }
                  }}
                  className="premium-select"
                />

                <Select
                  isMulti
                  options={croOptions}
                  placeholder="Select Cro's"
                  value={selectedCros}
                  onChange={(val) => {
                    setSelectedCros(val);
                    if (fromDate && toDate && selectedBranches.length > 0 && val && val.length > 0) {
                      setTimeout(() => setShowMobileFilters(false), 300);
                    }
                  }}
                  className="premium-select"
                />

                <div className="premium-search-bar">
                  <input
                    placeholder="Search Name / ID..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <div className="search-icon-btn">
                    <FiSearch />
                  </div>
                </div>
              </div>
            </div>

            <div className="master-list-section">
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                  padding: "16px",
                  flex: 1,
                  overflowY: "scroll",
                  scrollbarWidth: "thin",
                }}
              >
                {currentItems.length > 0 ? (
                  currentItems.map((member) => (
                    <div
                      key={member.id || member.member_id}
                      style={{
                        borderRadius: "5px",
                        padding: "16px",
                        width: "100%",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "15px",
                      }}
                    >
                      <div>
                        <div style={{ display: "flex" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "5px",
                              width: "35%",
                            }}
                          >
                            <Zoom>
                              <img
                                src={`${BASE_URL}/images/${member.memberPhoto}`}
                                width={60}
                                height={60}
                                alt="Member"
                                style={{
                                  borderRadius: "5px",
                                  marginRight: "10px",
                                }}
                              />
                            </Zoom>
                            <div style={{ textAlign: "left" }}>
                              <div>{member.memberName}</div>
                              <div>Prospect ID: {member.ApplicationId}</div>
                              {member.loanType !== "JLG Loan" && [
                                member.branchManagerStatus,
                                member.creditOfficerStatus,
                                member.misStatus,
                                member.creditManagerStatus,
                                member.sanctionCommitteeStatus,
                                member.accountManagerStatus
                              ].some(s => (s || "").toString().toLowerCase().trim() === "rejected") && (
                                <div style={{ color: "red", fontWeight: "bold", fontSize: "14px", marginTop: "4px" }}>Status: Rejected</div>
                              )}
                              {adminUser.userType === "Branch Manager" &&
                                filterStatus === "approved" && (
                                  <div>{member.branchManagerStatus}</div>
                                )}
                              {adminUser.userType === "MIS" &&
                                filterStatus === "approved" && (
                                  <div>{member.misStatus}</div>
                                )}
                            </div>
                          </div>
                          <div style={{ marginBottom: "8px", width: "20%" }}>
                            <MdDateRange
                              style={{
                                marginRight: "5px",
                                fontSize: "37px",
                                padding: "10px",
                                borderRadius: "5px",
                                backgroundColor: "rgba(15, 23, 42, 0.1)",
                                color: "#181818",
                              }}
                            />
                            {new Date(member.createdAt).toLocaleDateString(
                              "en-US",
                              {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                              }
                            )}
                          </div>
                          <div style={{ marginBottom: "8px", width: "20%" }}>
                            <FaLocationDot
                              style={{
                                marginRight: "5px",
                                fontSize: "35px",
                                padding: "10px",
                                borderRadius: "5px",
                                backgroundColor: "rgba(15, 23, 42, 0.1)",
                                color: "#181818",
                              }}
                            />
                            {member.branchName}
                          </div>
                          <div style={{ marginBottom: "8px", width: "20%" }}>
                            CRO: {member.croName}
                          </div>
                          <div style={{ marginBottom: "8px", width: "20%" }}>
                            Loan Amount: Rs.
                            {member.loanType === "Business Loan"
                              ? member.sanctionedLoanAmountBySanctionCommittee ??
                              member.proposedLoanAmount
                              : member.loanType === "GP Loan"
                                ? member.eligibleLoanAmountByBm ??
                                member.proposedLoanAmount
                                : member.proposedLoanAmount}
                          </div>
                          <div style={{ width: "15%" }}>
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="secondary"
                                id="dropdown-basic"
                                style={{
                                  backgroundColor: "#d4d4d8",
                                  border: "none",
                                  color: "#181818",
                                  fontSize: "15px",
                                  outline: "none",
                                }}
                              ></Dropdown.Toggle>

                              <Dropdown.Menu style={{ padding: "10px" }}>
                                <div style={{ display: "flex", gap: "10px" }}>
                                  <Dropdown.Item
                                    key="empty"
                                    className="p-0"
                                  ></Dropdown.Item>

                                  {[
                                    "Branch Manager",
                                    "Credit Manager",
                                    "MIS",
                                    "Sanction Committee",
                                    "Accounts Manager",
                                    "superadmin",
                                    "developer",
                                  ].includes(adminUser.userType) &&
                                    member.cbReport && (
                                      <Dropdown.Item
                                        key={member.cbReport}
                                        className="p-0"
                                      >
                                        <Button
                                          variant="primary"
                                          onClick={() =>
                                            window.open(
                                              `${BASE_URL}/images/${member.cbReport}`,
                                              "_blank"
                                            )
                                          }
                                        >
                                          <IoDocumentTextOutline />
                                        </Button>
                                      </Dropdown.Item>
                                    )}

                                  {[
                                    "Branch Manager",
                                    "Credit Manager",
                                    "MIS",
                                    "Sanction Committee",
                                    "Accounts Manager",
                                    "superadmin",
                                    "developer",
                                  ].includes(adminUser.userType) &&
                                    member.coApplicantCbReport && (
                                      <Dropdown.Item
                                        key={member.coApplicantCbReport}
                                        className="p-0"
                                      >
                                        <Button
                                          variant="primary"
                                          onClick={() =>
                                            window.open(
                                              `${BASE_URL}/images/${member.coApplicantCbReport}`,
                                              "_blank"
                                            )
                                          }
                                        >
                                          <IoDocumentTextOutline />
                                        </Button>
                                      </Dropdown.Item>
                                    )}

                                  {[
                                    "Branch Manager",
                                    "Credit Manager",
                                    "MIS",
                                    "Sanction Committee",
                                    "Accounts Manager",
                                    "superadmin",
                                    "developer",
                                  ].includes(adminUser.userType) &&
                                    member.pdf1 && (
                                      <Dropdown.Item
                                        key={member.pdf1}
                                        className="p-0"
                                      >
                                        <Button
                                          variant="primary"
                                          onClick={() =>
                                            window.open(
                                              `${BASE_URL}/images/${member.pdf1}`,
                                              "_blank"
                                            )
                                          }
                                        >
                                          <IoDocumentTextOutline />
                                        </Button>
                                      </Dropdown.Item>
                                    )}

                                  {[
                                    "Branch Manager",
                                    "Credit Manager",
                                    "MIS",
                                    "Sanction Committee",
                                    "Accounts Manager",
                                    "superadmin",
                                    "developer",
                                  ].includes(adminUser.userType) &&
                                    member.pdf2 && (
                                      <Dropdown.Item
                                        key={member.pdf2}
                                        className="p-0"
                                      >
                                        <Button
                                          variant="primary"
                                          onClick={() =>
                                            window.open(
                                              `${BASE_URL}/images/${member.pdf2}`,
                                              "_blank"
                                            )
                                          }
                                        >
                                          <IoDocumentTextOutline />
                                        </Button>
                                      </Dropdown.Item>
                                    )}

                                  <Dropdown.Item
                                    key={member.id}
                                    as="div"
                                    className="p-0"
                                  >
                                    <ActionButtons
                                      roleId={adminUser.userType}
                                      item={member}
                                      updateList={fetchMemberDetails}
                                      managerId={adminUser.user.id}
                                      proposedLoanAmount={
                                        member.proposedLoanAmount ?? 0
                                      }
                                      rateOfInterest={
                                        member.proposedLoanDetails
                                          ?.rateOfInterest ?? 0
                                      }
                                      tenureInMonths={
                                        member.proposedLoanDetails
                                          ?.tenureInMonths ?? 0
                                      }
                                      emiDateByCRO={
                                        member.proposedLoanDetails?.emiDate ??
                                        null
                                      }
                                      emiDateByBM={
                                        member.emiDateByBranchManager ?? null
                                      }
                                      fundingAgencyData={member.fundingAgencyData}
                                      loanType={member.loanType || loanType}
                                      loanStyle={member.loanStyle ?? loanStyle}
                                      bookingProcessDetails={
                                        member.bookingProcessDetails
                                      }
                                      aadharNo={member.aadharNo} // Added aadharNo prop
                                      handleDelMember={handleDelMember}
                                    />
                                  </Dropdown.Item>
                                </div>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            width: "100%",
                            borderRadius: "10px",
                          }}
                        >
                          <div
                            style={{
                              width: "15%",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <button
                              className="view-btn"
                              onClick={() => handleShowModal(member.id)}
                            >
                              View
                              <GrFormNext style={{ fontSize: "15px" }} />
                              <GrFormNext
                                style={{ fontSize: "18px", marginLeft: "-10px" }}
                              />
                            </button>
                          </div>

                          {/* Progress bar */}
                          <div
                            style={{
                              width: "85%",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <div className="step-container">
                              {/* <!-- Progress bar background --> */}
                              <div className="progress-bar">
                                <div
                                  className="progress"
                                  style={{
                                    width: `${getStepStatus(member).progressWidth}%`,
                                    backgroundColor: getStepStatus(member).progressColor,
                                  }}
                                ></div>
                              </div>

                              {/* <!-- Step items --> */}
                              {getStepStatus(member).steps.map((step, index) => (
                                <div
                                  key={index}
                                  className={`step ${step.active ? "active" : ""}`}
                                  style={
                                    step.active
                                      ? { backgroundColor: step.color }
                                      : {}
                                  }
                                >
                                  <FaUser className="num" />
                                  <span className="step-label">{step.label}</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center w-100">
                    No member data available.
                  </div>
                )}
              </div>

              {/* Custom Pagination */}
              <div className="master-pagination-wrapper" style={{ padding: 0, border: "none" }}>
                <nav className="pagination-container">
                  <div className="total-data-badge">
                    <FaUsers /> Total Data: <span>{filteredMembers.length}</span>
                  </div>

                  <ul className="premium-pagination">
                    <li>
                      <button
                        className="pagination-btn nav-btn"
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                      >
                        <FaAngleLeft style={{ marginRight: '6px' }} />
                        <span>Previous</span>
                      </button>
                    </li>

                    <li>
                      <div className="pagination-btn page-active">
                        Page <span>{currentPage}</span> / {totalPages}
                      </div>
                    </li>

                    <li>
                      <button
                        className="pagination-btn nav-btn"
                        disabled={currentPage === totalPages}
                        onClick={() => handlePageChange(currentPage + 1)}
                      >
                        <span>Next</span>
                        <FaAngleRight style={{ marginLeft: '6px' }} />
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <MemberDetailsModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          memberId={selectedMemberId}
        />
      )}

      <DeleteConfirmationModal
        showModal={showDelModal}
        handleClose={() => setShowDelModal(false)}
        handleSubmitAlert={handleSubmitAlert}
      />
      <DeveloperDeleteModal
        showModal={showDevDelModal}
        handleClose={() => setShowDevDelModal(false)}
        onDeleteSuccess={fetchMemberDetails}
        memberId={selectedMemberId}
      />
    </section>
  );
};

export default MemberDetails;